import React from "react";

/**
 * Official SoKno Productions logo.
 * The provided JPG already includes the wordmark + "PRODUCTIONS" sublabel,
 * so we render just the image. `size` controls the rendered height; width
 * follows the asset's natural square proportions.
 *
 * The asset has a black background — it sits seamlessly on the SoKno
 * theme without needing a transparent PNG.
 */
export default function SoKnoLogo({
  size = 64,
  className = "",
  // `withText` kept for backwards-compatibility with previous API; ignored
  // because the logo asset already carries the wordmark.
  // eslint-disable-next-line no-unused-vars
  withText = true,
}) {
  return (
    <img
      src="/sokno-logo.png"
      alt="SoKno Productions"
      width={size}
      height={size}
      data-testid="sokno-logo"
      className={`block select-none ${className}`}
      style={{
        height: size,
        width: "auto",
        objectFit: "contain",
        background: "transparent",
      }}
      draggable={false}
    />
  );
}
